var React = require('react');

function LogoTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.0425 0H19.096L12.4249 7.62462L20.2729 18H14.128L9.31507 11.7074L3.80799 18H0.752606L7.88799 9.84461L0.359375 0H6.6603L11.0108 5.75169L16.0425 0ZM14.9708 16.1723H16.6628L5.74091 1.73169H3.92522L14.9708 16.1723Z","fill":"currentColor"}));
}

LogoTwitter.defaultProps = {"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none"};

module.exports = LogoTwitter;

LogoTwitter.default = LogoTwitter;
